import { PropsWithChildren, useMemo, useState } from 'react';
import { useFetchAllPhysiciansQuery } from '@api/physicians/physiciansAPI';
import { ScheduleContext } from './ScheduleContext';

export const ScheduleContextProvider = ({ children }: PropsWithChildren) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const localStorageLocationId = localStorage.getItem('locationSchedule');

  const [selectedLocationId, setSelectedLocationId] = useState<string | null>(
    localStorageLocationId,
  );

  const [selectedPhysician, setSelectedPhysician] = useState<string | null>(null);

  const [selectedPatient, setSelectedPatient] = useState<string | null>(null);

  const [selectedType, setSelectedType] = useState<string | null>(null);

  const [selectedTrial, setSelectedTrial] = useState<string | null>(null);

  const [selectedHourFrom, setSelectedHourFrom] = useState<string | null>(null);

  const [selectedHourTo, setSelectedHourTo] = useState<string | null>(null);

  const { data: physicians, refetch } = useFetchAllPhysiciansQuery();

  const [blackoutErrorMessage, setBlackoutErrorMessage] = useState<string | null>(null);

  const contextValues = {
    selectedDate,
    selectedPhysician,
    selectedPatient,
    selectedType,
    selectedTrial,
    selectedHourFrom,
    selectedHourTo,
    physicians,
    refetch,
    blackoutErrorMessage,
    selectedLocationId,
    setSelectedLocationId: (locationId: string) => setSelectedLocationId(locationId),
    setDate: (date: Date) => setSelectedDate(date),
    setSelectedPhysician: (physician: string) => setSelectedPhysician(physician),
    setSelectedPatient: (patient: string) => setSelectedPatient(patient),
    setSelectedType: (type: string) => setSelectedType(type),
    setSelectedTrial: (trial: string) => setSelectedTrial(trial),
    setSelectedHourFrom: (hourFrom: string) => setSelectedHourFrom(hourFrom),
    setSelectedHourTo: (hourTo: string) => setSelectedHourTo(hourTo),
    setBlackoutErrorMessage: (message: string) => setBlackoutErrorMessage(message),
  };

  const cachedProvider = useMemo(() => contextValues, [contextValues]);

  return <ScheduleContext.Provider value={cachedProvider}>{children}</ScheduleContext.Provider>;
};
